<div class="menu-crud-panel-food-lower">
	<div class="panel-content">
		<div class="panel-list">
			@for (
					record of (svcDataFood.getRecordsLogToday() | async); track record.id) {
				<div class="meal-item" (click)="selectedRecord = record" [ngClass]="{'meal-item-selected':selectedRecord && selectedRecord.id === record.id}">
					<div class="meal-type">{{record.ai.analysis.mealType}}</div>
					<div class="meal-time">{{record.timestamp.toDate() | date: "HH:mm"}}</div>
				</div>
			}
		</div>
		<div class="panel-drilldown">
			<div class="review-meal">
				@if (selectedRecord) {
					@for (
							item of selectedRecord.ai.analysis.items; track item.name) {
						<div class="text-row">
							<div class="text-row-icon">
								<i class="fa-sharp fal" [ngClass]="'fa-'+FoodAnalysisRatingDict[item.processingLevel].icon"></i>
							</div>
							<div class="text-row-inner">{{item.name | titlecase}}</div>
						</div>
						<div class="text-row">
							<div class="text-row-inner">{{item.portionEstimate}}</div>
						</div>
						<div class="text-row">
							@for (
									tag of item.dietaryTags; track tag) {
								<div>{{tag | titlecase}}</div>
							}
						</div>
						<div class="nutrition-row">
							<div class="nutrition-row-item">{{item.calories}}</div>
							<div class="nutrition-row-value">{{item.calories}}kcal</div>
						</div>
						@for (
								detail of foodAnalysisNutritionDetailKeys; track detail + $index) {
							@let
							dict = foodAnalysisNutritionDetailDict[detail];
							<div class="nutrition-row">
								<div class="nutrition-row-item">{{dict.name}}</div>
								<div class="nutrition-row-value">{{item[detail].grams}}{{dict.unit}}</div>
								<div class="nutrition-row-icon">
									<i class="fa-sharp fal" [ngClass]="'fa-'+FoodAnalysisRatingDict[item[detail].level].icon"></i>
								</div>
							</div>
						}
					}
				}
			</div>
		</div>
	</div>
	<div class="panel-footer"></div>
</div>